import React, { useState, useEffect } from 'react';

import ManageDetailsDisplay from './ManageDetailsDisplay';
import { MessageModal } from '../MessageModal';

import 'bootstrap/dist/css/bootstrap.min.css'
import '../../../styles.css'

const sptGQLURI = process.env.REACT_APP_SPT_GQL_URI;

const emptySampleType = {
    "SampleType_ID": "",
    "SampleType_VC": ""
};
const emptyLab = {
    "Lab_ID": "",
    "Lab_VC": ""
};
const emptyDetail = {
    deliveryId: "",
    trackingNumber: "",
    deliveryType: "",
    fiscalYear: "",
    labNumber: "",
    sampleType: "",
    lab: "",
    scanDate: "",
    printDate: "",
    account: "",
    scannedBy: "",
    updatedBy: "",
    printedBy: "",
    labId: "",
    lastUpdatedById: "",
    sampleDeliveryTypeId: "",
    sampleTypeId: "",
    scanById: ""
};
// Wait this long after the last keystroke before searching
const SEARCH_DEBOUNCE_MS = 400;


const ManageDetails = (props) => {
    const {
        globalVs,
        labs,
        sampleTypes,
        labsLoading
    } = props;
    const [servitechTrackingId, setServitechTrackingId] = useState("");
    const [labNumber, setLabNumber] = useState("");
    const [sampleType, setSampleType] = useState(emptySampleType);
    const [lab, setLab] = useState(emptyLab);
    const [fiscalYear, setFiscalYear] = useState("");
    const [details, setDetails] = useState([emptyDetail])
    const [selectedSamples, setSelectedSamples] = useState([]);
    const [deliveryTypes, setDeliveryTypes] = useState([
        {
            SampleDeliveryType_ID: '',
            SampleDeliveryType_VC: ''
        }
    ])
    const [deliveryTypesLoading, setDeliveryTypesLoading] = useState(true)
    const [sampleToEdit, setSampleToEdit] = useState('');
    const [editModal, setEditModal] = useState(false)

    const [showMessageModal, setShowMessageModal] = useState(false)
    const [displayMessage, setDisplayMessage] = useState("");

    async function fetchData() {
        const getSampleDeliveryTypesQuery = `
            { 
                getSampleDeliveryType {
                    SampleDeliveryType_ID
                    SampleDeliveryType_VC
                }
            }`
            ;
        try {
            const getSampleDeliveryTypesFetch = await fetch(sptGQLURI, { method: 'POST', body: JSON.stringify({ query: getSampleDeliveryTypesQuery }), headers: { 'Content-Type': 'application/json' } });
            const getSampleDeliveryTypesJSON = await getSampleDeliveryTypesFetch.json();
            if (getSampleDeliveryTypesJSON && getSampleDeliveryTypesJSON.data && getSampleDeliveryTypesJSON.data.getSampleDeliveryType) {
                setDeliveryTypes(getSampleDeliveryTypesJSON.data.getSampleDeliveryType)
            }
        } catch (err) {
            console.error(err);
        }
        setDeliveryTypesLoading(false)
    }

    const handleUpdateManageDetails = (e) => {
        e.preventDefault();
        const value = e.target.value;
        switch (e.target.id) {
            case "prefServitechTrackingID":
                setServitechTrackingId(value)
                break;
            case "prefLabNumber":
                setLabNumber(value)
                break;
            case "prefSampleType":
                const st = sampleTypes.find(x => x.SampleType_VC === value);
                setSampleType(st || emptySampleType)
                break;
            case "prefLab":
                const l = labs.find(x => x.Lab_VC === value);
                setLab(l || emptyLab)
                break;
            case "prefFiscalYear":
                setFiscalYear(value)
                break;
            default:
                break;
        }
    }

    const handleSelectUnSelectSamples = (sample) => {
        if (selectedSamples.includes(sample)) {
            // Sample is already selected, unselect it
            setSelectedSamples((prevSelectedSamples) => prevSelectedSamples.filter((x) => x !== sample));
        } else {
            // Sample is not selected, select it
            setSelectedSamples((prevSelectedSamples) => [...prevSelectedSamples, sample]);
        }
    };

    const toDetailRow = (x) => {
        let sSampleType = '';
        if (x.SampleType_ID !== "" && x.SampleType_ID !== null && x.SampleType_ID !== undefined) {
            const newV = sampleTypes.find(sSample => parseInt(sSample.SampleType_ID) === parseInt(x.SampleType_ID))
            sSampleType = newV ? newV.SampleType_VC : String(x.SampleType_ID);
        }
        return {
            deliveryId: x.SamplePackageTracking_ID || "",
            trackingNumber: x.TrackingNumber_VC || "",
            deliveryType: x.SampleDeliveryType_VC || "",
            fiscalYear: x.FiscalYear_ID || "",
            labNumber: x.LabNumber_IN || "",
            sampleType: sSampleType,
            lab: x.Lab_VC || "",
            scanDate: x.Scan_DT || "",
            printDate: x.Print_DT || "",
            account: x.Account_VC || "",
            scannedBy: x.ScannedBy || "",
            updatedBy: x.UpdatedBy || "",
            printedBy: x.PrintedBy || "",
            labId: x.Lab_ID || "",
            lastUpdatedById: x.LastUpdatedBy_ID || "",
            sampleDeliveryTypeId: x.SampleDeliveryType_ID || "",
            sampleTypeId: x.SampleType_ID || "",
            scanById: x.ScanBy_ID || ""
        };
    }

    const setDetailsFromResults = (results) => {
        setDetails(results && results.length ? results.map(toDetailRow) : [emptyDetail]);
        setSelectedSamples([]);
    }

    const hasSampleFilters = () => {
        return labNumber !== "" || sampleType.SampleType_ID !== "" || lab.Lab_ID !== "" || fiscalYear !== "";
    }

    // Re-run whichever search produced the current grid
    const refreshGrid = () => {
        if (servitechTrackingId !== "") {
            getGridDataByTNFunction()
        } else if (hasSampleFilters()) {
            getGridDataBySampleFunction()
        } else {
            setDetailsFromResults([])
        }
    }

    async function getGridDataBySampleFunction() {
        let getDataToFillGridQuery = `{ GetDataToFillGrid(`
        if (labNumber !== "") {
            getDataToFillGridQuery += ` searchLnTxt:${JSON.stringify(labNumber)}`
        }
        if (sampleType.SampleType_ID !== "") {
            getDataToFillGridQuery += ` selectedSearchSt:${JSON.stringify(sampleType.SampleType_ID)}`
        }
        if (lab.Lab_ID !== "") {
            getDataToFillGridQuery += ` selectedSearchLab:${JSON.stringify(lab.Lab_ID)}`
        }
        if (fiscalYear !== "") {
            getDataToFillGridQuery += ` fiscalYearId:${JSON.stringify(fiscalYear)}`
        }

        getDataToFillGridQuery += `
            ) {
                Account_VC
                FiscalYear_ID
                Lab_ID
                LabNumber_IN
                LastUpdatedBy_ID
                Print_DT
                PrintedBy
                SampleDeliveryType_ID
                SamplePackageTracking_ID
                SampleType_ID
                Scan_DT
                ScanBy_ID
                ScannedBy
                TrackingNumber_VC
                UpdatedBy
                SampleDeliveryType_VC
                Lab_VC
            }
        }`;

        try {
            const getDataToFillGridFetch = await fetch(sptGQLURI, { method: 'POST', body: JSON.stringify({ query: getDataToFillGridQuery }), headers: { 'Content-Type': 'application/json' } });
            const getDataToFillGridJson = await getDataToFillGridFetch.json();
            setDetailsFromResults(getDataToFillGridJson && getDataToFillGridJson.data && getDataToFillGridJson.data.GetDataToFillGrid)
        } catch (err) {
            console.error(err);
            setDetailsFromResults([])
        }
    }

    async function getGridDataByTNFunction() {
        const getSamplePackageTrackingByIdQuery = `
            {
                getSamplePackageTrackingById(id:${JSON.stringify(servitechTrackingId)}){
                    Account_VC
                    FiscalYear_ID
                    Lab_ID
                    LabNumber_IN
                    LastUpdatedBy_ID
                    Print_DT
                    PrintedBy
                    SampleDeliveryType_ID
                    SamplePackageTracking_ID
                    SampleType_ID
                    Scan_DT
                    ScanBy_ID
                    ScannedBy
                    TrackingNumber_VC
                    UpdatedBy
                    SampleDeliveryType_VC
                    Lab_VC
                }
            }
        `;

        try {
            const getSamplePackageTrackingByIdFetch = await fetch(sptGQLURI, { method: 'POST', body: JSON.stringify({ query: getSamplePackageTrackingByIdQuery }), headers: { 'Content-Type': 'application/json' } });
            const getSamplePackageTrackingByIdJSON = await getSamplePackageTrackingByIdFetch.json();
            setDetailsFromResults(getSamplePackageTrackingByIdJSON && getSamplePackageTrackingByIdJSON.data && getSamplePackageTrackingByIdJSON.data.getSamplePackageTrackingById)
        } catch (err) {
            console.error(err);
            setDetailsFromResults([])
        }
    }

    const handleCheckItem = () => {
        // Skip the empty placeholder row shown when there are no results
        const allSamples = details.filter((x) => x.deliveryId !== "");
        setSelectedSamples(allSamples);
    };

    const handleUnCheckItem = () => {
        setSelectedSamples([]);
    };

    const handleEditSample = async (e, ste) => {
        e.preventDefault();
        const updateSamplePackageTrackingQuery = `
            {
                updateSamplePackageTracking(
                    trackingNumVc:${JSON.stringify(ste.trackingNumber)},
                    sampleDeliverytypeId:${JSON.stringify(String(ste.sampleDeliveryTypeId))},
                    fiscalYearId:${JSON.stringify(String(ste.fiscalYear))},
                    labNumberIn:${JSON.stringify(String(ste.labNumber))},
                    accountVc:${JSON.stringify(ste.account)},
                    sampleTypeId:${JSON.stringify(String(ste.sampleTypeId))},
                    labId:${JSON.stringify(String(ste.labId))},
                    g_AdminUser_ID:${JSON.stringify(globalVs.AdminUser_ID)},
                    samplePackageTrackingId:${JSON.stringify(ste.deliveryId)}
                )
            }
        `;
        let result;
        try {
            const updateSamplePackageTrackingFetch = await fetch(sptGQLURI, { method: 'POST', body: JSON.stringify({ query: updateSamplePackageTrackingQuery }), headers: { 'Content-Type': 'application/json' } });
            result = await updateSamplePackageTrackingFetch.json();
        } catch (err) {
            console.error(err);
        }
        setEditModal(false)
        if (result && result.data && result.data.updateSamplePackageTracking === 'Sample Updated') {
            setDisplayMessage("Edit Was Successful")
        } else {
            setDisplayMessage("Could Not Edit. Please Contact IT.")
        }
        setShowMessageModal(true)
        setTimeout(() => {
            setShowMessageModal(false)
            setDisplayMessage("")
            refreshGrid()
        }, 3000)
    }

    const handleDeleteItem = async (e) => {
        const toDelete = selectedSamples.filter((x) => x.deliveryId !== "");
        if (!toDelete.length) {
            return;
        }
        if (!window.confirm(`Delete ${toDelete.length} selected sample(s)? This cannot be undone.`)) {
            return;
        }
        let failed = 0;
        for (let index = 0; index < toDelete.length; index++) {
            const element = toDelete[index];
            const deleteSamplePackageTrackingQuery = `
            {
                deleteSamplePackageTracking(
                    samplePackageTrackingId:${JSON.stringify(element.deliveryId)}
                )
            }
        `;
            try {
                const deleteSamplePackageTrackingFetch = await fetch(sptGQLURI, { method: 'POST', body: JSON.stringify({ query: deleteSamplePackageTrackingQuery }), headers: { 'Content-Type': 'application/json' } });
                const deleteResult = await deleteSamplePackageTrackingFetch.json();
                if (!deleteSamplePackageTrackingFetch.ok || !deleteResult || deleteResult.errors || !deleteResult.data) {
                    failed++;
                }
            } catch (err) {
                console.error(err);
                failed++;
            }
        }
        if (failed === 0) {
            setDisplayMessage("The Selected Sample(s) have been Deleted")
        } else {
            setDisplayMessage(`${failed} of ${toDelete.length} Sample(s) Could Not Be Deleted. Please Contact IT.`)
        }
        setShowMessageModal(true)
        setTimeout(() => {
            setShowMessageModal(false)
            setDisplayMessage("")
            setSelectedSamples([])
            refreshGrid()
        }, 3000)
    }

    useEffect(() => {
        fetchData()
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (hasSampleFilters()) {
            setServitechTrackingId("")
            const timer = setTimeout(getGridDataBySampleFunction, SEARCH_DEBOUNCE_MS)
            return () => clearTimeout(timer)
        } else if (servitechTrackingId === "") {
            // All filters were cleared
            setDetailsFromResults([])
        }
        // eslint-disable-next-line
    }, [labNumber, sampleType, lab, fiscalYear])

    useEffect(() => {
        if (servitechTrackingId !== "") {
            setLabNumber("")
            setSampleType(emptySampleType)
            setLab(emptyLab)
            setFiscalYear("")
            const timer = setTimeout(getGridDataByTNFunction, SEARCH_DEBOUNCE_MS)
            return () => clearTimeout(timer)
        } else if (!hasSampleFilters()) {
            // Tracking ID was cleared
            setDetailsFromResults([])
        }
        // eslint-disable-next-line
    }, [servitechTrackingId])

    useEffect(() => {
        if (selectedSamples && selectedSamples.length === 1) {
            setSampleToEdit(selectedSamples)
        } else {
            setSampleToEdit('')
        }
    }, [selectedSamples])

    return (
        <>
            <ManageDetailsDisplay
                servitechTrackingId={servitechTrackingId}
                labNumber={labNumber}
                sampleType={sampleType}
                lab={lab}
                details={details}
                handleUpdateManageDetails={handleUpdateManageDetails}
                handleSelectUnSelectSamples={handleSelectUnSelectSamples}
                handleCheckItem={handleCheckItem}
                handleUnCheckItem={handleUnCheckItem}
                handleDeleteItem={handleDeleteItem}
                sampleTypeOs={sampleTypes}
                labOs={labs}
                deliveryOptions={deliveryTypes}
                deliveryTypesLoading={deliveryTypesLoading}
                labsLoading={labsLoading}
                selectedSamples={selectedSamples}
                sampleToEdit={sampleToEdit}
                handleEditSample={handleEditSample}
                editModal={editModal}
                setEditModal={setEditModal}
                fiscalYear={fiscalYear}
            />
            <MessageModal
                isOpen={showMessageModal}
                setShowEmailModal={setShowMessageModal}
                displayMessage={displayMessage}
            />
        </>
    )
}
export default ManageDetails;